@if (screenWidth > 480) {
<div>
  @if (!displayOnly) {
  <div class="shareTypeSelection">
    @if (showShareTypeOptions) {
    <span class="app__centered-item shareTypeText">
      <span class="flex fl-justify-center fl-al-center" style="min-width: 32px" [ngClass]="this.isSealed ? 'eve-icon' : ''">
        @if (this.isSealed) {
        <mat-icon>notifications</mat-icon>
        }
      </span>
      <button [class]="checkAccessibility(shareDetails.share_date)">
        {{ checkAccessibilityTag(shareDetails.share_date) }}
        @if (checkAccessibilityTag(shareDetails.share_date) == '') {
        <span>&nbsp;{{ shareDetails.share_date | date }}</span>
        }
      </button>
      <!-- <img
            style="margin-left: 21px; cursor: pointer"
            src="../../../../../assets/images/editSharingIcon.svg"
            class="shared-img-icon"
            (click)="shareTypeSelectionClicked()"
            /> -->
    </span>
    }
    <span class="app__centered-item">
      <button mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true">
        <span class="material-icons text-[#25508e]">more_vert</span>
      </button>
      <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
        @if (showShareTypeOptions) {
        <button mat-menu-item class="popup-menu-item remove-link" (click)="shareTypeSelectionClicked()">
          <span class="material-icons menuitem-icon text-base">edit</span>
          <span class="relative top-[-3px] left-[2px]"> Edit </span>
        </button>
        }
        <button mat-menu-item class="popup-menu-item remove-link text-[#ff0000]" (click)="deleteExistingUser()">
          <img src="assets/images/trash-2.svg" style="width: 16px" />
          <span style="position: relative; top: 1px; left: 2px"> Remove </span>
        </button>
      </mat-menu>
    </span>
  </div>
  } @if (displayOnly && showShareTypeOptions) {
  <div class="shareTypeSelection">
    <p>
      {{ shareTypeText }}@if (isSealed) {
      <i matTooltip="Sealed" [matTooltipPosition]="'below'" class="material-icons infoIcon">preview</i>
      }
    </p>
  </div>
  }
</div>
} @if (screenWidth <= 480 && !onlyEditIcon && showShareTypeOptions) {
<div>
  @if (!displayOnly) {
  <div class="shareTypeSelection">
    <p class="shareTypeText">
      <span class="flex fl-justify-center fl-al-center" [ngClass]="this.isSealed ? 'eve-icon' : ''">
        @if (this.isSealed) {
        <mat-icon>notifications</mat-icon>
        }
      </span>
      <button [class]="checkAccessibility(shareDetails.share_date)">
        {{ checkAccessibilityTag(shareDetails.share_date) }}
        @if (checkAccessibilityTag(shareDetails.share_date) == '') {
        <span>&nbsp;{{ shareDetails.share_date | date }}</span>
        }
      </button>
    </p>
  </div>
  } @if (displayOnly) {
  <div class="shareTypeSelection">
    {{ shareTypeText }}
  </div>
  }
</div>
} @if (screenWidth <= 480 && onlyEditIcon && showShareTypeOptions) {
<div>
  <img
    style="margin-left: 21px; cursor: pointer"
    src="../../../../../assets/images/editSharingIcon.svg"
    class="shared-img-icon"
    (click)="shareTypeSelectionClicked()"
  />
</div>
}
